import { useState, ReactElement } from 'react'

interface TabHeadingWidths {
  readonly [key: string]: number
}

/**
 * Manages state specific to the animation of the tab headings and sliding bar.
 */
export function TabAnimationManager({
  children
}: {
  readonly children: (props: {
    readonly transitionToggleFlag: boolean
    readonly updateToggleFlag: (flag: boolean) => void
    readonly tabHeadingWidths: TabHeadingWidths
    readonly updateTabHeadingWidths: (widths: TabHeadingWidths) => void
  }) => ReactElement<any>
}) {
  const [transitionToggleFlag, updateToggleFlag] = useState(true)
  const [tabHeadingWidths, updateTabHeadingWidths] = useState<TabHeadingWidths>(
    {}
  )
  return children({
    transitionToggleFlag,
    updateToggleFlag,
    tabHeadingWidths,
    updateTabHeadingWidths
  })
}
